export var FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
export var FETCH_USER_SUCCEED = 'FETCH_USER_SUCCEED';
export var FETCH_USER_FAIL = 'FETCH_USER_FAIL';
export var UPDATE_USER_VISIT = 'UPDATE_USER_VISIT';
export var UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export var UPDATE_USER_FAIL = 'UPDATE_USER_FAIL';
export var UPDATE_USER_SUCCEED = 'UPDATE_USER_SUCCEED';
export var CREATE_KYC_REQUEST = 'CREATE_KYC_REQUEST';
export var CREATE_KYC_FAIL = 'CREATE_KYC_FAIL';
export var CREATE_KYC_SUCCEED = 'CREATE_KYC_SUCCEED';
export var UPDATE_INDIVIDUAL_KYC_REQUEST = 'UPDATE_INDIVIDUAL_KYC_REQUEST';
export var UPDATE_INDIVIDUAL_KYC_SUCCESS = 'UPDATE_INDIVIDUAL_KYC_SUCCESS';
export var UPDATE_INDIVIDUAL_KYC_FAIL = 'UPDATE_INDIVIDUAL_KYC_FAIL';
export var UPDATE_BANK_REQUEST = 'UPDATE_BANK_REQUEST';
export var UPDATE_BANK_SUCCESS = 'UPDATE_BANK_SUCCESS';
export var UPDATE_BANK_FAIL = 'UPDATE_BANK_FAIL';
export var FETCH_BANK_REQUEST = 'FETCH_BANK_REQUEST';
export var FETCH_BANK_SUCCESS = 'FETCH_BANK_SUCCESS';
export var FETCH_BANK_ERROR = 'FETCH_BANK_ERROR';
export var UPDATE_USER_MODIFICATION_REQUEST = 'UPDATE_USER_MODIFICATION_REQUEST';
export var UPDATE_USER_SOCIETY = 'UPDATE_USER_SOCIETY';
export var ADD_USER_SOCIETY = 'ADD_USER_SOCIETY';
